$(document).ready(function() {

    // Set Header height as global css variable
    $(window).on('resize', function() {
        const headerHeight = $('.page-header .header').outerHeight();
        document.querySelector('html').style.setProperty('--header-height', `${headerHeight}px`);
    })

    // Trigger resize event after page has loaded
    $(window).trigger('resize');
});
